import { CeuValue } from './ceuValues';
import { OperationProof } from './operationProof';
import { ProductOperation } from './productOperation';
import { Vehicle } from './vehicle';

export interface Operation {
  id?: string;
  displayName?: string;
  code?: string;
  creator?: string;
  type?: string;
  rank?: number;
  description?: string;
  hasError?: boolean;
  operationProofs?: OperationProof[];
  detailedOperation?: {
    inputProducts?: ProductOperation[];
    outputProducts?: ProductOperation[];
    vehicles?: Vehicle[];
    ceuValues?: CeuValue[];
    tunneling?: TunnelingProjectUsageResourceModel[];
    dredging?: DredgingProjectUsageResourceModel[];
  };
  periodId?: string;
  copiedFromOperationId?: string;
  // nulle tant que personne n'a saisi, modifié ou supprimé une ligne : la copie porte alors encore les
  // quantités de la solution initiale
  adjustedDate?: string;
}

export enum ETunnelingState {
  New = 1,
  Recycled = 2,
  Reassembled = 3
}
export enum ETunnelingSupportEquipementType {
  CoolingTower = 1 << 0,
  Convoyer = 1 << 1,
  HydroBelt = 1 << 2,
  ConcretePlant = 1 << 3,
  SludgePlant = 1 << 4,
  WaterTreatment = 1 << 5,
  SludgeTreatment = 1 << 6,
  Train = 1 << 7
}

export interface TunnelingProjectUsageResourceModel {
  id?: string;
  displayName: string;
  description?: string;
  presenceDuration?: number;
  networkDuration?: number;
  generatorDuration?: number;
  fileDescription?: string;
  fileName?: string;
  buildComment?: string;
  equipementState?: ETunnelingState;
  grosWeight?: number;
  buildPhaseCo2EqPerDay?: number;
  buildPhaseCo2Eq?: number;
  transportationComment?: string;
  transportationDistance?: number;
  transportationPhaseCo2EqPerDay?: number;
  transportationPhaseCo2Eq?: number;
  usagePhaseComment?: string;
  equipementPower?: number;
  equipementPowerConsumption?: number;
  usagePhaseCo2EqPerDay?: number;
  usagePhaseCo2Eq?: number;
  totalEquipementCo2EqPerDay?: number;
  totalEquipementCo2Eq?: number;
  equipementSuportComment?: string;
  equipementSuportMass?: number;
  equipementSuportPower?: number;
  equipementSuportConsumedPower?: number;
  supportEquipmentCo2EqPerDay?: number;
  supportEquipmentCo2Eq?: number;
  equipementSuportSelected?: ETunnelingSupportEquipementType[];
  grandTotalCo2EqPerDay?: number;
  grandTotalCo2Eq?: number;
  grandTotalMj?: number;
  selectedFuel?: string;
  energyName?: string;
  createDate?: string;
  creator?: string;
  updateDate?: string;
  modifier?: string;
}

export interface DredgingProjectUsageResourceModel {
  id?: string;
  displayName: string;
  bringPhaseComment?: string;
  bringPhaseFuelConsumption?: number;
  bringPhaseCo2Eq?: number;
  execPhaseComment?: string;
  execPhaseDuration?: number;
  execPhaseFuelConsumption?: number;
  execPhaseCo2Eq?: number;
  totalFuelConsumption?: number;
  totalCo2Eq?: number;
  totalMj?: number;
  fileName?: string;
  fileDescription?: string;
  selectedFuel?: string;
  selectedFuelName?: string;
  selectedFuelCo2PerLiter?: number;
  selectedFuelCo2PerMj?: number;
  createDate?: string;
  creator?: string;
  updateDate?: string;
  modifier?: string;
}
